<template>
  <div class="global-navs" v-show="isAtTop">
    <!-- PC -->
    <v-toolbar id="g-header-nav" class="pc">
      <div class="col-left flex1">
        <v-toolbar-side-icon
          v-if="!drawer"
          @click.stop="
            drawOpen();
            onCloseSecondHeader();
          "
        ></v-toolbar-side-icon>
        <v-toolbar-side-icon v-if="drawer" @click.stop="drawClose()">
          <v-icon>close</v-icon>
        </v-toolbar-side-icon>
        <v-text-field
          hide-details
          prepend-icon="search"
          single-line
          v-model="searchWord"
          label=""
          placeholder="検索"
          class="insite-search"
          @focus="onShowSearchHistories"
          @blur="onHideSearchHistories"
          @keyup="onShowSearchHistories"
          @keypress.enter="search(null)"
        ></v-text-field>
        <div class="g-pc-search-histories " v-show="showSearchHistories">
          <div>
            <p><strong>検索履歴</strong></p>
          </div>
          <div>
            <p
              v-for="history in searchedHistories"
              :key="history"
              class="g-pc-search-history-item"
              v-show="searchingHistories.includes(history)"
              @click="search(history)"
            >
              {{ history }}
            </p>
          </div>
        </div>
      </div>

      <v-toolbar-title class="site-title flex1">
        <div>
          <a href="/">
            NCB Library
          </a>
          <p>金融・決済の ”なぜ?!” が見える</p>
        </div>
      </v-toolbar-title>

      <v-toolbar-items
        v-if="!user.id"
        class="header-login hidden-sm-and-down flex1"
      >
        <div class="locale1"></div>

        <v-btn flat href="/login"
          >ログイン・新規登録<br />(スタンダード会員無料)</v-btn
        >
      </v-toolbar-items>

      <v-toolbar-items v-else class="header-login hidden-sm-and-down flex1">
        <div class="locale1"></div>

        <v-list class="pa-1" v-if="user.id">
          <v-list-tile avatar :href="'/users/' + user.id">
            <v-list-tile-avatar class="header-user-avatar">
              <img :src="userAvatar" />
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title class="user-name" v-if="user.name">{{
                user.name
              }}</v-list-tile-title>
              <v-list-tile-title class="user-name" v-else
                >匿名ユーザー</v-list-tile-title
              >
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar-items>

      <template v-slot:extension>
        <v-toolbar-items class="header-sns-box hidden-sm-and-down">
          <div class="header-sns-list">
            <a href="https://twitter.com/ncb_since1989" target="_blank">
              <img src="/images/x-logo-black.png" class="sns-icon-small" />
            </a>
            <a href="https://www.youtube.com/c/NCBLounge" target="_blank">
              <img src="/images/youtube-icon.png" class="sns-icon" />
            </a>
          </div>
        </v-toolbar-items>
        <v-toolbar-items class="header-categories">
          <v-list>
            <v-list-tile class="js-show-news" @click="onToggleSecondHeader()">
              <span>ニュース</span>
              <v-icon
                :small="true"
                color="rgb(0, 66, 189)"
                v-if="!showSecondHeader"
              >
                fas fa-chevron-down
              </v-icon>
              <v-icon :small="true" color="rgb(0, 66, 189)" v-else>
                fas fa-chevron-up
              </v-icon>
            </v-list-tile>

            <v-list-tile href="/reports/ncb_report">レポート</v-list-tile>

            <v-list-tile href="/seminars">セミナー</v-list-tile>

            <v-list-tile :href="navigationPostLinks.forLB"
              >eラーニング</v-list-tile
            >

            <v-list-tile :href="navigationPostLinks.forNCBConsulting"
              >コンサルティング</v-list-tile
            >
          </v-list>
        </v-toolbar-items>

        <v-toolbar-items
          v-if="!user.id"
          class="header-planregister hidden-sm-and-down"
        >
          <v-btn
            flat
            id="header_cta"
            :href="navigationPostLinks.forPlanInfo"
            class="js-testA-btn"
          >
            無料体験14日間
          </v-btn>
        </v-toolbar-items>

        <v-toolbar-items
          v-if="user.id && user.division == 1"
          class="header-paidplan hidden-sm-and-down"
        >
          <v-btn flat href="/register/plan_select">
            プレミアム登録<br class="tablet" />はこちら
          </v-btn>
        </v-toolbar-items>

        <v-toolbar-items
          v-if="user.id && isLb"
          class="header-lbplan hidden-sm-and-down"
        >
          <v-btn flat @click="lbBtn()" class="lb-small">
            eラーニング<br class="tablet" />はこちら
          </v-btn>
        </v-toolbar-items>
      </template>

      <div id="g-second-header-nav" v-show="showSecondHeader">
        <v-container>
          <v-layout row class="second-header-row">
            <v-flex class="second-header-col-left">
              <p
                :class="{
                  'second-header-item-title': true,
                  'selected-line': showFirstSecondHeaderRow,
                }"
                @mouseover="onShowFirstRow()"
              >
                オリジナル記事
              </p>
              <p
                :class="{
                  'second-header-item-title': true,
                  'selected-line': showSecondSecondHeaderRow,
                }"
                @mouseover="onShowSecondRow()"
              >
                動画
              </p>
              <a href="/categories/news/curation">
                <p
                  :class="{
                    'second-header-item-title-with-link': true,
                    'selected-line': showThirdSecondHeaderRow,
                  }"
                  @mouseover="onShowThirdRow()"
                >
                  キュレーション記事
                </p>
              </a>
              <p
                :class="{
                  'second-header-item-title': true,
                  'selected-line': showFourthSecondHeaderRow,
                }"
                @mouseover="onShowFourthRow()"
              >
                Fintech DB / 用語集
              </p>
            </v-flex>

            <v-flex class="second-header-col-right">
              <div v-show="showFirstSecondHeaderRow">
                <p class="mb10">
                  <a href="/categories/global-news">
                    <p class="second-header-child-title">グローバルニュース</p>
                    <small>
                      <span class="second-header-child-caption-arrow"></span>
                      海外の注目動向を毎日配信
                    </small>
                  </a>
                </p>
                <p class="mb10">
                  <a href="/features/114">
                    <p class="second-header-child-title">5 Pick Up</p>
                    <small>
                      <span class="second-header-child-caption-arrow"></span>
                      国内ニュース1週間おまとめ
                    </small>
                  </a>
                </p>
                <p class="mb10">
                  <a href="/features/85">
                    <p class="second-header-child-title">FinTech 50</p>
                    <small>
                      <span class="second-header-child-caption-arrow"></span>
                      上場50社の週間株価動向
                    </small>
                  </a>
                </p>
                <p class="mb10">
                  <a href="/features/86">
                    <p class="second-header-child-title">米国決算レポート</p>
                    <small>
                      <span class="second-header-child-caption-arrow"></span>
                      注目企業の決算を深掘り
                    </small>
                  </a>
                </p>
              </div>
              <div v-show="showSecondSecondHeaderRow">
                <p class="mb10">
                  <a href="/features/22">
                    <p class="second-header-child-title">Diggingセミナー</p>
                    <small>
                      <span class="second-header-child-caption-arrow"></span>
                      重要トレンドを深掘り解説
                    </small>
                  </a>
                </p>
                <p class="mb10">
                  <a href="/features/87">
                    <p class="second-header-child-title">Premium Workout</p>
                    <small>
                      <span class="second-header-child-caption-arrow"></span>
                      旬な話題の裏側にせまる
                    </small>
                  </a>
                </p>
                <p class="mb10">
                  <a href="/features/62">
                    <p class="second-header-child-title">Short Interview</p>
                    <small>
                      <span class="second-header-child-caption-arrow"></span>
                      企業の担当者本人に直撃
                    </small>
                  </a>
                </p>
              </div>
              <div v-show="showThirdSecondHeaderRow"></div>
              <div v-show="showFourthSecondHeaderRow">
                <p class="mb10">
                  <a href="/fintechs">
                    <p class="second-header-child-title">Fintech DB</p>
                    <small>
                      <span class="second-header-child-caption-arrow"></span>
                      1億ドル以上の資金調達企業を更新
                    </small>
                  </a>
                </p>
                <p>
                  <a href="/features/24">
                    用語集
                  </a>
                </p>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </div>

      <div
        id="g-second-header-nav-blur"
        v-show="showSecondHeader"
        @click="onToggleSecondHeader()"
      ></div>
    </v-toolbar>
    <!-- PC END -->

    <!-- SP -->
    <v-toolbar id="g-header-nav-sp" class="sp">
      <div class="col-left">
        <v-toolbar-side-icon
          v-if="!drawer"
          @click.stop="
            drawOpen();
            onCloseSecondHeader();
          "
        ></v-toolbar-side-icon>
        <v-toolbar-side-icon v-if="drawer" @click.stop="drawClose()">
          <v-icon>close</v-icon>
        </v-toolbar-side-icon>
      </div>

      <v-toolbar-title class="site-title">
        <div>
          <a href="/">
            NCB Library
          </a>
          <p>金融・決済の ”なぜ?!” が見える</p>
        </div>
      </v-toolbar-title>

      <div v-if="!user.id" class="col-right">
        <a href="/login">
          <button class="login-btn">
            ログイン
          </button>
        </a>
      </div>
    </v-toolbar>
    <!-- SP END -->

    <!-- sidenav -->
    <aside v-show="drawer" id="g-side-nav">
      <v-container style="height: 100%; padding: 8px;">
        <v-layout row class="second-header-row" style="height: 100%;">
          <v-flex class="second-header-col-left">
            <v-list style="padding: 0;" v-if="user.id">
              <v-list-tile avatar :href="'/users/' + user.id">
                <v-list-tile-avatar>
                  <img :src="userAvatar" />
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title v-if="user.name">{{
                    user.name
                  }}</v-list-tile-title>
                  <v-list-tile-title v-else>匿名ユーザー</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile
                href="/register/plan_select"
                v-if="user.id && user.division == 1"
              >
                <v-list-tile-content>
                  <v-list-tile-title class="sp-login"
                    >プレミアム登録はこちら</v-list-tile-title
                  >
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="lbBtn()" v-if="user.id && isLb">
                <v-list-tile-content>
                  <v-list-tile-title class="sp-login lb-small"
                    >eラーニングはこちら</v-list-tile-title
                  >
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-list class="pa-1" v-else>
              <v-list-tile avatar href="/login">
                <v-list-tile-content>
                  <v-list-tile-title class="sp-login"
                    >ログイン・新規登録<br />
                    <span style="font-size: 11px;">(スタンダード会員無料)</span>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile
                id="header_cta"
                :href="navigationPostLinks.forPlanInfo"
                v-if="!user.id"
              >
                <v-list-tile-content>
                  <v-list-tile-title class="sp-planregister js-testA-text"
                    >無料体験14日間</v-list-tile-title
                  >
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-list class="pt-0 sidenav">
              <v-divider></v-divider>

              <v-text-field
                hide-details
                prepend-icon="search"
                single-line
                v-model="searchWord"
                label=""
                placeholder="検索"
                class="insite-search-sp"
                @focus="onShowSearchHistories"
                @keyup="onShowSearchHistories"
                @keypress.enter="search(null)"
              ></v-text-field>
              <v-list-tile @click="onToggleSecondDrawer()" class="h-30px">
                <v-list-tile-title>
                  ニュース
                  <v-icon
                    :small="true"
                    color="rgb(0, 66, 189)"
                    v-if="!showSecondDrawer"
                    style="margin-bottom: 4px;"
                  >
                    fas fa-chevron-down
                  </v-icon>
                  <v-icon
                    :small="true"
                    color="rgb(0, 66, 189)"
                    style="margin-bottom: 4px;"
                    v-else
                  >
                    fas fa-chevron-up
                  </v-icon>
                </v-list-tile-title>
              </v-list-tile>

              <div
                style="padding-left: 10px; padding-top: 4px;"
                v-show="showSecondDrawer"
              >
                <v-list-tile @click="onShowFirstRow()" class="h-30px">
                  <v-list-tile-title>
                    <p
                      :class="{
                        mb0: true,
                        'second-header-item-title': true,
                        'selected-line': showFirstSecondHeaderRow,
                      }"
                    >
                      オリジナル記事
                    </p>
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="onShowSecondRow()" class="h-30px">
                  <v-list-tile-title>
                    <p
                      :class="{
                        mb0: true,
                        'second-header-item-title': true,
                        'selected-line': showSecondSecondHeaderRow,
                      }"
                    >
                      動画
                    </p>
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  href="/categories/news/curation"
                  @click="onShowThirdRow()"
                  class="h-30px"
                >
                  <v-list-tile-title>
                    <p
                      :class="{
                        mb0: true,
                        'second-header-item-title': true,
                      }"
                    >
                      キュレーション記事
                    </p>
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="onShowFourthRow()" class="h-30px">
                  <v-list-tile-title>
                    <p
                      :class="{
                        mb0: true,
                        'second-header-item-title': true,
                        'selected-line': showFourthSecondHeaderRow,
                      }"
                    >
                      Fintech DB / 用語集
                    </p>
                  </v-list-tile-title>
                </v-list-tile>
              </div>

              <v-list-tile href="/reports/ncb_report" class="h-30px">
                <v-list-tile-title>レポート</v-list-tile-title>
              </v-list-tile>

              <v-list-tile href="/seminars" class="h-30px">
                <v-list-tile-title>セミナー</v-list-tile-title>
              </v-list-tile>

              <v-list-tile :href="navigationPostLinks.forLB" class="h-30px">
                <v-list-tile-title>eラーニング</v-list-tile-title>
              </v-list-tile>

              <v-list-tile
                :href="navigationPostLinks.forNCBConsulting"
                class="h-30px"
              >
                <v-list-tile-title>コンサルティング</v-list-tile-title>
              </v-list-tile>

              <v-list-tile href="/about/about.html" class="h-30px">
                <v-list-tile-title>NCBについて</v-list-tile-title>
              </v-list-tile>

              <v-list class="sns-list">
                <a href="https://twitter.com/ncb_since1989" target="_blank">
                  <img src="/images/x-logo-black.png" class="sns-icon-small" />
                </a>
                <a href="https://www.youtube.com/c/NCBLounge" target="_blank">
                  <img src="/images/youtube-icon.png" class="sns-icon" />
                </a>
              </v-list>
            </v-list>
          </v-flex>
          <v-flex class="second-header-col-right">
            <div v-show="showSearchHistories">
              <div>
                <p><strong>検索履歴</strong></p>
              </div>
              <div>
                <p
                  v-for="history in searchedHistories"
                  :key="history"
                  class="g-pc-search-history-item"
                  v-show="searchingHistories.includes(history)"
                  @click="search(history)"
                >
                  {{ history }}
                </p>
              </div>
            </div>
            <div v-show="showFirstSecondHeaderRow">
              <p class="mb10">
                <a href="/categories/global-news">
                  <p class="second-header-child-title">グローバルニュース</p>
                  <small class="second-header-child-caption-sp">
                    <span class="second-header-child-caption-arrow"></span>
                    海外の注目動向を毎日配信
                  </small>
                </a>
              </p>
              <p class="mb10">
                <a href="/features/114">
                  <p class="second-header-child-title">5 Pick Up</p>
                  <small class="second-header-child-caption-sp">
                    <span class="second-header-child-caption-arrow"></span>
                    国内ニュース1週間おまとめ
                  </small>
                </a>
              </p>
              <p class="mb10">
                <a href="/features/85">
                  <p class="second-header-child-title">FinTech 50</p>
                  <small class="second-header-child-caption-sp">
                    <span class="second-header-child-caption-arrow"></span>
                    上場50社の週間株価動向
                  </small>
                </a>
              </p>
              <p class="mb10">
                <a href="/features/86">
                  <p class="second-header-child-title">米国決算レポート</p>
                  <small class="second-header-child-caption-sp">
                    <span class="second-header-child-caption-arrow"></span>
                    注目企業の決算を深掘り
                  </small>
                </a>
              </p>
            </div>
            <div v-show="showSecondSecondHeaderRow">
              <p class="mb10">
                <a href="/features/22">
                  <p class="second-header-child-title">Diggingセミナー</p>
                  <small class="second-header-child-caption-sp">
                    <span class="second-header-child-caption-arrow"></span>
                    重要トレンドを深掘り解説
                  </small>
                </a>
              </p>
              <p class="mb10">
                <a href="/features/87">
                  <p class="second-header-child-title">Premium Workout</p>
                  <small class="second-header-child-caption-sp">
                    <span class="second-header-child-caption-arrow"></span>
                    旬な話題の裏側にせまる
                  </small>
                </a>
              </p>
              <p class="mb10">
                <a href="/features/62">
                  <p class="second-header-child-title">Short Interview</p>
                  <small class="second-header-child-caption-sp">
                    <span class="second-header-child-caption-arrow"></span>
                    企業の担当者本人に直撃
                  </small>
                </a>
              </p>
            </div>
            <div v-show="showThirdSecondHeaderRow"></div>
            <div v-show="showFourthSecondHeaderRow">
              <p class="mb10">
                <a href="/fintechs">
                  <p class="second-header-child-title">Fintech DB</p>
                  <small class="second-header-child-caption-sp">
                    <span class="second-header-child-caption-arrow"></span>
                    1億ドル以上の資金調達企業を更新
                  </small>
                </a>
              </p>
              <p class="mb10">
                <a href="/features/24">
                  用語集
                </a>
              </p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </aside>
  </div>
</template>

<script>
import axios from "axios";

const querystring = require("querystring");

export default {
  props: {
    user: Object,
    userAvatar: String,
    categories: Array,
    url: String,
    login: String,
    scoId: String,
    time: String,
    addAccount: String,
    keyVal: String,
    isLb: String,
    accessToken: String,
    jaLocaleIconPath: String,
    enLocaleIconPath: String,
  },

  data() {
    return {
      isAtTop: true,
      drawer: false,
      showSecondHeader: false,
      showSecondDrawer: false,
      showFirstSecondHeaderRow: true,
      showSecondSecondHeaderRow: false,
      showThirdSecondHeaderRow: false,
      showFourthSecondHeaderRow: false,
      searchWord: "",
      searchingHistories: JSON.parse(localStorage.getItem("searched_items"))
        ? JSON.parse(localStorage.getItem("searched_items")).slice(0, 5)
        : [],
      searchedHistories: JSON.parse(localStorage.getItem("searched_items"))
        ? JSON.parse(localStorage.getItem("searched_items"))
        : [],
      showSearchHistories: false,
      navigationPostLinks: {},
    };
  },

  methods: {
    onScroll() {
      // 現在のスクロール位置がページ上部より下なら非表示、上なら表示
      if (!this.drawer) {
        this.isAtTop = window.scrollY === 0;
      }
    },

    onCloseSecondHeader() {
      this.showSecondHeader = false;
    },

    onToggleSecondHeader() {
      this.showSecondHeader = !this.showSecondHeader;
    },

    onToggleSecondDrawer() {
      this.showSecondDrawer = !this.showSecondDrawer;
    },

    onShowFirstRow() {
      this.showFirstSecondHeaderRow = true;
      this.showSecondSecondHeaderRow = false;
      this.showThirdSecondHeaderRow = false;
      this.showFourthSecondHeaderRow = false;

      this.showSearchHistories = false;
    },

    onShowSecondRow() {
      this.showFirstSecondHeaderRow = false;
      this.showSecondSecondHeaderRow = true;
      this.showThirdSecondHeaderRow = false;
      this.showFourthSecondHeaderRow = false;

      this.showSearchHistories = false;
    },

    onShowThirdRow() {
      this.showFirstSecondHeaderRow = false;
      this.showSecondSecondHeaderRow = false;
      this.showThirdSecondHeaderRow = true;
      this.showFourthSecondHeaderRow = false;

      this.showSearchHistories = false;
    },

    onShowFourthRow() {
      this.showFirstSecondHeaderRow = false;
      this.showSecondSecondHeaderRow = false;
      this.showThirdSecondHeaderRow = false;
      this.showFourthSecondHeaderRow = true;

      this.showSearchHistories = false;
    },

    scroll_control(event) {
      event.preventDefault();
    },

    drawOpen() {
      this.drawer = true;
      document.addEventListener("mousewheel", this.scroll_control, {
        passive: false,
      });
      document.addEventListener("touchmove", this.scroll_control, {
        passive: false,
      });
    },

    drawClose() {
      this.drawer = false;
      document.removeEventListener("mousewheel", this.scroll_control, {
        passive: false,
      });
      document.removeEventListener("touchmove", this.scroll_control, {
        passive: false,
      });
    },

    search(word) {
      const searchWord = word || this.searchWord;
      const filteredItems = this.searchedHistories.filter(function(item) {
        return item !== searchWord;
      });

      filteredItems.unshift(searchWord);

      // 最大50個
      if (filteredItems.length > 50) {
        filteredItems.slice(0, 50);
      }

      localStorage.setItem("searched_items", JSON.stringify(filteredItems));

      location.href = "/search/news?w=" + searchWord;
      return false;
    },

    onShowSearchHistories() {
      this.showFirstSecondHeaderRow = false;
      this.showSecondSecondHeaderRow = false;
      this.showThirdSecondHeaderRow = false;
      this.showFourthSecondHeaderRow = false;

      const searchWord = this.searchWord;

      let searchHistories = this.searchedHistories;

      if (searchWord !== "") {
        searchHistories = this.searchedHistories.filter(function(item) {
          return item.startsWith(searchWord);
        });
      }

      // 最大5個
      this.searchingHistories = searchHistories.slice(0, 5);
      this.showSearchHistories = true;
    },

    onHideSearchHistories() {
      setTimeout(this.hideSearchHistories, 250);
    },

    hideSearchHistories() {
      this.showSearchHistories = false;
    },

    getKeyword(search) {
      return vars;
    },

    lbBtn() {
      if (this.accessToken) {
        const lbUrl =
          this.url +
          "&login=" +
          this.login +
          "&sco_id=" +
          this.scoId +
          "&time=" +
          this.time +
          "&key=" +
          this.keyVal +
          "&add_account=" +
          this.addAccount;
        window.open(lbUrl, "_blank");
      } else {
        window.location.href = "/lb404";
      }
      return false;
    },
  },
  mounted() {
    // スクロールイベントのリスナーを追加
    window.addEventListener("scroll", this.onScroll);

    if (location.search) {
      const search = location.search.replace("?", "");
      this.searchWord =
        querystring.parse(search).w || querystring.parse(search).word;
    }

    // 案内記事のリンクを取得
    axios
      .get("/api/navigation-post-links")
      .then((response) => {
        this.navigationPostLinks = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  beforeDestroy() {
    // コンポーネントが破棄される前にイベントリスナーを削除
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>

<style lang="scss">
@import "../../sass/variables";

.global-navs {
  z-index: 100;
}

@media (min-width: 1024px) {
  .flex1 {
    flex: 1;
  }
}

.locale1 {
  line-height: 60px;
}

.localeButton {
  color: rgb(32, 32, 32);
  padding: 5px;
  margin-left: 2px;
  font-size: 14px;
  border: #e6e6e6 1px solid;
  border-radius: 1px;
}

.localeButton:hover {
  background: #e6e6e6;
}

.localeButtonSp {
  padding: 0 16px;
  line-height: 30px;
  cursor: pointer;
}

.localeButtonIcon {
  width: 20px;
  vertical-align: middle;
}

.h-30px {
  height: 30px;
  & .v-list__tile {
    height: 30px;
  }
}

@media (max-width: 1023px) {
  .locale1 {
    display: none;
  }
}

.sp-planregister {
  color: $white !important;
  font-size: 14px;
  width: inherit !important;
  padding: 5px 10px;
}

.js-testA-text {
  background-color: $cKey;
}

.js-testA-btn {
  .v-btn__content {
    background-color: $cKey;
  }
}

.second-header-child-title {
  margin-bottom: 0px !important;
}
.second-header-child-caption-sp {
  font-size: 10px;
}
.second-header-child-caption-arrow {
  position: relative;
  display: inline-block;
  padding: 5px;

  &::before {
    content: "";
    width: 5px;
    height: 5px;
    border-bottom: solid 1px $cKey;
    border-left: solid 1px $cKey;
    position: absolute;
    left: 5px;
    top: 2px;
  }
}

// Medium ~
@media (min-width: 751px) {
  #g-header-nav {
    position: fixed;
    top: 0;
    z-index: 2;
    border-bottom: 10px solid #202020;
    background: white;
    box-shadow: 0 0 20px 0 cBaseDk(20);
    > .v-toolbar__content {
      height: 60px !important;
      padding: 0 12px;
    }
    > .v-toolbar__extension {
      height: 60px !important;
      margin-top: 14px;
      padding: 0 12px;
    }

    .col-left {
      display: flex;
      position: relative;
      .v-toolbar__side-icon {
        display: none !important;
      }
      .insite-search {
        height: 40px;
        width: 200px;
        background: rgb(239, 239, 239);
        padding-left: 10px;
        padding-top: 5px;
        border-radius: 5px;
        flex: initial;
        .v-input__slot {
          margin-bottom: 0;
        }
        .v-text-field__details {
          display: none;
        }
        & > .v-input__control {
          & > .v-input__slot:before {
            border: none !important;
          }
          & > .v-input__slot {
            font-size: 14px;
          }
          & > .v-input__slot:after {
            border: none !important;
          }
        }
      }
    }
    .site-title {
      position: relative;
      top: 8px;
      margin: 0 auto;
      font-size: 2rem;
      font-weight: 900;
      text-align: center;
      a {
        display: block;
        color: #202020;
        font-size: 2.2rem;
        font-family: "Open Sans", sans-serif;
      }
      p {
        color: $cText;
        font-size: 12px;
        font-weight: 500;
        margin-bottom: 10px;
        font-family: sans-serif !important;
      }
    }
    .header-login {
      justify-content: end;
      position: relative;
      top: 8px;
      overflow: hidden;
      white-space: nowrap;
      display: flex;
      align-items: center;
      a {
        font-weight: 300;
        &:hover {
          opacity: 1;
        }
      }
      .user-name {
        color: $cText;
        line-height: unset;
      }
      .v-list__tile--avatar {
        padding: 0;
      }
      // .v-list {
      //   margin-left: auto;
      //   margin-right: auto;
      // }
      .header-user-avatar {
        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
        min-width: unset;
        margin-right: 5px;
        .v-list__tile__content {
          height: auto !important;
        }
      }
      .v-btn__content {
        color: $cKey;
        text-align: center;
      }
    }
    .header-planregister {
      position: absolute;
      top: 70px;
      right: 25px;
      overflow: hidden;
      white-space: nowrap;
      display: flex;
      align-items: center;
      a {
        font-weight: 300;
        &:hover {
          opacity: 1;
        }
      }
      .user-name {
        color: $cText;
        line-height: unset;
      }
      .v-list__tile--avatar {
        padding: 0;
      }
      .v-list {
        margin-left: auto;
        margin-right: auto;
      }
      .v-btn__content {
        padding: 5px 10px;
        // ABテスト用に別クラスへ
        // background-color: $cKey;
        color: $white;
        text-align: center;
      }
    }
    .header-paidplan {
      position: absolute;
      top: 70px;
      right: 5px;
      overflow: hidden;
      white-space: nowrap;
      display: flex;
      align-items: center;
      height: auto;
      a {
        font-weight: 300;
        &:hover {
          opacity: 1;
        }
      }
      .user-name {
        color: $cText;
        line-height: unset;
      }
      .v-list__tile--avatar {
        padding: 0;
      }
      .v-list {
        margin-left: auto;
        margin-right: auto;
      }
      .v-btn__content {
        color: $cKey;
        text-align: center;
      }
    }
    .header-lbplan {
      position: absolute;
      top: 95px;
      right: 5px;
      overflow: hidden;
      white-space: nowrap;
      display: flex;
      align-items: center;
      height: auto;
      a {
        font-weight: 300;
        &:hover {
          opacity: 1;
        }
      }
      .user-name {
        color: $cText;
        line-height: unset;
      }
      .v-list__tile--avatar {
        padding: 0;
      }
      .v-list {
        margin-left: auto;
        margin-right: auto;
      }
      .v-btn__content {
        color: $cKey;
        text-align: center;
      }
    }
    .lb-small {
      text-transform: none !important;
    }
    .header-categories {
      display: inline-block;
      height: auto;
      margin: 0 auto;
      padding: 0;
      .v-list {
        margin: 0;
        padding: 0;
        text-align: center;
        background: inherit;
        & > div {
          display: inline-block;
          & > a {
            @include centerY;
            font-size: 1.3rem;
            font-weight: bold;
            &:link,
            &:visited {
              color: rgba(0, 0, 0, 0.87);
            }
            &:hover {
              opacity: 1;
            }
          }
        }
      }
    }
    .header-sns-box {
      position: absolute;
      display: flex;
      overflow: hidden;
      white-space: nowrap;
      .header-sns-list {
        display: flex;
        align-items: center;
        a {
          margin-right: 15px;
          display: flex;
          align-items: center;
          .sns-icon {
            width: 35px;
            height: 35px;
            object-fit: contain;
          }
          .sns-icon-small {
            width: 30px;
            height: 30px;
            object-fit: contain;
          }
        }
      }
    }
  }

  .tablet {
    display: none;
  }

  .js-show-news {
    > .v-list__tile {
      font-size: 1.3rem;
      font-weight: bold;
      cursor: pointer;
      > span {
        padding-right: 5px;
      }
    }
  }

  #g-second-header-nav {
    position: fixed;
    top: 144px;
    left: 0;
    width: 100%;
    background: #ffffff;
    height: 290px;
  }

  #g-second-header-nav-blur {
    background: rgba(33, 33, 33, 0.87);
    position: fixed;
    width: 100%;
    top: 434px;
    left: 0;
    height: 100vh;
  }

  .second-header-row {
    width: 100%;
    display: flex;
  }

  .second-header-col-left {
    width: 50%;
    border-right: solid 1px #e0e0e0;
  }

  .second-header-col-right {
    width: 50%;
    padding-left: 50px;
    height: 240px;
  }

  .second-header-item-title {
    width: 50%;
    min-width: 150px;
    cursor: default;
  }

  .second-header-item-title-with-link {
    width: 50%;
    cursor: pointer;
    color: #000000;
  }

  .selected-line {
    border-bottom: solid 1px #e0e0e0;
  }

  #g-side-nav {
    position: fixed;
    top: 144px;
    width: 100%;
    height: 100%;
    background: #ffffff;
    z-index: 10;
  }

  .g-pc-search-histories {
    position: absolute;
    background: white;
    z-index: 10;
    border: 1px solid gray;
    padding: 10px;
    top: 50px;
    width: 300px;
  }
}

// Small
@media screen and (max-width: 750px) {
  #g-header-nav-sp {
    position: fixed;
    top: 0;
    z-index: 2;
    border-bottom: 10px solid #202020;
    background: white;
    box-shadow: 0 0 20px 0 cBaseDk(20);
    > .v-toolbar__content {
      height: 65px !important;
      border-bottom: 1px solid cBaseDk(15);
    }
    > .v-toolbar__extension {
      display: none;
    }
    .col-left {
      display: flex;
      position: absolute;
      top: 10px;
      left: 0;
      > .v-btn {
        height: 30px;
        width: 30px;
      }
    }
    .col-right {
      display: flex;
      position: absolute;
      top: 15px;
      right: 15px;
    }
    .site-title {
      @include centerXY;
      height: 50px;
      margin: 0 auto;
      font-size: 1.8rem;
      font-weight: 900;
      text-align: center;
      padding-top: 10px;
      a {
        display: block;
        color: #202020;
        font-size: 1.6rem;
        line-height: 1;
        font-family: "Open Sans", sans-serif;
      }
      p {
        color: $cText;
        margin-top: 8px;
        margin-bottom: 8px;
        font-size: 10px;
        font-weight: 500;
        font-family: sans-serif !important;
      }
    }

    .v-toolbar__content,
    .v-toolbar__extension {
      padding: 0;
    }
  }

  .login-btn {
    padding: 10px;
    border: 1px solid rgb(203 213 225);
    line-height: 16px;
    border-radius: 5px;
    color: rgb(15 23 42);
    font-size: 12px;
  }

  #g-side-nav {
    position: fixed;
    top: 74px;
    width: 100%;
    height: 100%;
    background: #ffffff;
    z-index: 10;

    .insite-search-sp {
      background: rgb(239, 239, 239);
      padding-left: 10px;
      border-radius: 5px;
      width: 80%;
      &.v-text-field {
        padding-top: 5px;
        margin: 10px 15px;
      }
      & > .v-input__control {
        & > .v-input__slot:before {
          border: none !important;
        }
        & > .v-input__slot {
          font-size: 14px;
        }
        & > .v-input__slot:after {
          border: none !important;
        }
      }
    }
    .v-list__tile__title {
      color: $cText;
      height: fit-content;
    }
    .sp-login {
      color: $cKey;
      font-size: 14px;
    }
  }

  .second-header-row {
    width: 100%;
    display: flex;
  }

  .second-header-col-left {
    width: 50%;
    border-right: solid 1px #e0e0e0;
  }

  .second-header-col-right {
    width: 50%;
    padding-left: 5%;
  }

  .second-header-item-title {
    width: 50%;
    cursor: default;
    font-size: 13px;
  }

  .second-header-item-title-with-link {
    width: 50%;
    cursor: pointer;
  }

  .selected-line {
    border-bottom: solid 1px #e0e0e0;
  }
}

// Medium
@media screen and (max-width: 1024px) {
  .sns-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    padding: 16px;
    font-size: 14px;
    & > a {
      margin-right: 20px;
      display: flex;
      align-items: center;
      .sns-icon {
        width: 35px;
        height: 35px;
        object-fit: contain;
      }
      .sns-icon-small {
        width: 30px;
        height: 30px;
        object-fit: contain;
      }
    }
  }
}

@media (min-width: 751px) and (max-width: 1023px) {
  #g-header-nav {
    .col-left {
      position: absolute;
      top: 8px;
      left: 0;
      .v-toolbar__side-icon {
        display: block !important;
      }
    }
    .header-login {
      position: absolute;
      top: 8px;
      right: 0;
      overflow: hidden;
      white-space: nowrap;
      display: flex;
      align-items: center;
    }
    .header-categories {
      .v-list {
        & > div {
          & > a {
            @include centerY;
            height: 50px;
          }
        }
      }
    }
    .header-paidplan {
      .v-btn__content {
        text-align: end;
      }
      a {
        padding: 5px;
      }
    }
    .header-sns-box {
      display: none;
    }
    .tablet {
      display: block !important;
    }
  }

  .insite-search-sp {
    background: rgb(239, 239, 239);
    padding-left: 10px;
    border-radius: 5px;
    width: 80%;
    &.v-text-field {
      padding-top: 5px;
      padding-bottom: 5px;
      margin: 10px 15px;
      margin-top: 25px;
    }
    & > .v-input__control {
      & > .v-input__slot:before {
        border: none !important;
      }
      & > .v-input__slot {
        font-size: 14px;
      }
      & > .v-input__slot:after {
        border: none !important;
      }
    }
  }

  #g-side-nav {
    .v-list__tile__title {
      color: $cText;
      height: fit-content;
    }
    .sp-login {
      color: $cKey;
    }
  }
}

@media (max-width: 799px) {
  #g-header-nav .header-categories .v-list > div > a:link {
    font-size: 16px;
  }
}

@media (max-width: 450px) {
  #g-header-nav {
    .header-categories {
      .v-list {
        & > div {
          & > a {
            padding: 0 3px !important;
            font-size: 3.2vw !important;
          }
        }
      }
    }
  }
}

@media (max-width: 960px) {
  #g-second-header-nav-blur {
    top: 420px;
  }
}

.g-pc-search-history-item {
  cursor: pointer;
  font-size: 14px !important;
}
</style>
